import { render } from "./AddOffer.vue?vue&type=template&id=4195f060&scoped=true"
import script from "./AddOffer.vue?vue&type=script&lang=js"
export * from "./AddOffer.vue?vue&type=script&lang=js"

import "./AddOffer.vue?vue&type=style&index=0&id=4195f060&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4195f060"]])

export default __exports__